import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function orderPromotionsLoad(orderId, filters = {}) {
  const url = `/${API_VERSION_ONE}/orders/${orderId}/promotions`;
  const method = 'GET';
  const params = {
    ...filters,
  };

  return {
    type: 'ORDER_PROMOTIONS_LOAD',
    payload: handleAPI(url, params, method),
    meta: { page: filters.page || 1 },
  };
}

export function orderPromotionsReset() {
  return { type: 'ORDER_PROMOTIONS_RESET' };
}

export function orderPromotionPreviewLoad(orderId, promotionId, filters = {}) {
  const url = `/${API_VERSION_ONE}/orders/${orderId}/promotions/${promotionId}`;
  const method = 'GET';
  const params = {
    ...filters,
  };

  return {
    type: 'ORDER_PROMOTION_PREVIEW_LOAD',
    payload: handleAPI(url, params, method),
  };
}

export function orderPromotionPreviewClear() {
  return { type: 'ORDER_PROMOTION_PREVIEW_CLEAR' };
}

export function orderPromotionApply(orderId, body, filters = {}) {
  const url = `/${API_VERSION_ONE}/orders/${orderId}`;
  const method = 'PUT';
  const params = {
    ...filters,
  };

  return {
    type: 'ORDER_PROMOTION_APPLY',
    payload: handleAPI(url, params, method, body),
  };
}

export function orderPromotionRemove(orderId, body, filters = {}) {
  const url = `/${API_VERSION_ONE}/orders/${orderId}`;
  const method = 'PUT';
  const params = {
    ...filters,
  };

  return {
    type: 'ORDER_PROMOTION_REMOVE',
    payload: handleAPI(url, params, method, body),
  };
}
